import styles from "./HeaderProsthetic.module.scss";
import prostheticPicture from '../../../shared/assets/photo/Prosthetic/prosthetic.png';
import prostheticPicture_2x from '../../../shared/assets/photo/Prosthetic/prosthetic_2x.png';
import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import prostheticPictureMob from '../../../shared/assets/photo/Prosthetic/prostheticMob.png';
import prostheticPictureMob_2x from '../../../shared/assets/photo/Prosthetic/prostheticMob2x.png';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP); 

const HeaderProsthetic = () => {

    useGSAP(() => {
        gsap.fromTo(".prosthetic__header", {opacity: 0,  y:10,}, 
                                    { opacity: 1,
                                    y:0,  
                                    duration: 1, 
                                    });
    }, [])

    return ( 
        <div>
            <div className={styles.content}>
                <img className={styles.picture} src={prostheticPicture}
                    srcSet={`${prostheticPicture_2x} 2x`} alt="эстетическая стоматология" />

                <img className={styles.pictureMob} src={prostheticPictureMob}
                    srcSet={`${prostheticPictureMob_2x} 2x`} alt="эстетическая стоматология" />
            <Stack              
                    justifyContent='justifyCenter'
                    alignItems ='alignCenter'
                    className={styles.header}>
                <Text
                    type='h1' 
                    size ='xxl'
                    className={`prosthetic__header ${styles.title}`}>
                        Протезирование
                </Text>
            </Stack>
            </div>
        </div>
    );
}
export default HeaderProsthetic;